import { CatalogPage } from "@/features/catalog/pages/CatalogPage";
import { AppIcon } from "@/shared/components/AppIcon";

export const RestaurantMenuPage = (): React.ReactElement => (
  <div className="space-y-4">
    <section className="rounded-3xl border border-amber-100 bg-amber-50 p-4 sm:p-5 dark:border-amber-900/50 dark:bg-amber-950/20">
      <div className="flex gap-3"><span className="grid size-11 shrink-0 place-items-center rounded-2xl bg-amber-500 text-white"><AppIcon name="box" size={20} /></span><div><h1 className="font-black text-slate-950 dark:text-white">مدیریت منوی رستوران</h1><p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">دسته‌هایی مثل پیش‌غذا، غذای اصلی، نوشیدنی و دسر بسازید و هر آیتم را با قیمت و وضعیت موجودی تعریف کنید. این منو مستقیماً در صندوق رستوران استفاده می‌شود.</p></div></div>
    </section>
    <CatalogPage />
  </div>
);
